<template>
    <div
        class="df-mnav"
        :class="{ 'is-open': open }"
        :aria-hidden="(!open).toString()">
        <div class="df-mnav__scroll">
            <div
                v-for="section in sections"
                :key="section.key"
                class="df-mnav__block">
                <!-- 可展开 -->
                <template v-if="section.type === 'accordion'">
                    <button
                        type="button"
                        class="df-mnav__head"
                        @click="toggle(section.key)">
                        <span>{{ $t(section.title) }}</span>
                        <i
                            class="el-icon-arrow-down df-mnav__arrow"
                            :class="{ 'is-open': expandedKey === section.key }"></i>
                    </button>
                    <div
                        v-show="expandedKey === section.key"
                        class="df-mnav__panel">
                        <div v-if="section.key === 'models'" class="df-mnav__category-tabs">
                            <button
                                v-for="category in carCategories"
                                :key="category"
                                type="button"
                                class="df-mnav__category-tab"
                                :class="{ 'is-active': category === selectedCarCategory }"
                                @click="$emit('car-category-select', category)">
                                {{ category }}
                            </button>
                        </div>
                        <div
                            v-for="(group, gi) in section.groups"
                            :key="section.key + '-' + gi"
                            class="df-mnav__group">
                            <div v-if="group.title" class="df-mnav__cat">{{ group.title }}</div>
                            <div class="df-mnav__list">
                                <a
                                    v-for="(item, ii) in group.items"
                                    :key="section.key + '-' + gi + '-' + ii"
                                    href="javascript:;"
                                    class="df-mnav__item"
                                    @click.prevent="onItemClick(item)">
                                    <span class="df-mnav__item-name">{{ formatItemName(section, item) }}</span>
                                    <span v-if="item.price" class="df-mnav__item-price">{{ item.price }}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </template>

                <!-- 直跳 -->
                <a
                    v-else
                    href="javascript:;"
                    class="df-mnav__link"
                    @click.prevent="onItemClick(section)">
                    {{ $t(section.title) }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MobileNavMenu',
        props: {
            open: {
                type: Boolean,
                default: false,
            },
            loggedIn: {
                type: Boolean,
                default: false,
            },
            modelGroups: {
                type: Array,
                default: () => [],
            },
            carCategories: {
                type: Array,
                default: () => [],
            },
            selectedCarCategory: {
                type: String,
                default: '',
            },
            techGroups: {
                type: Array,
                default: () => [],
            },
        },
        data() {
            return {
                // 记录用户最后展开的折叠项，菜单重新打开或路由跳转后继续沿用
                expandedKey: 'models',
            };
        },
        computed: {
            sections() {
                const list = [
                    {
                        key: 'models',
                        title: '车型',
                        type: 'accordion',
                        groups: this.modelGroups.map(group => ({
                            title: group.title,
                            items: group.items.map(car => ({
                                id: car.id,
                                name: car.name,
                                price: this.$i18n.locale === 'en'
                                    ? [car.priceUnit, car.priceNum].filter(Boolean).join(' ')
                                    : [car.priceNum, car.priceUnit].filter(Boolean).join(' '),
                                path: car.path,
                            })),
                        })),
                    },
                    {
                        key: 'technology',
                        title: '技术',
                        type: 'accordion',
                        groups: this.techGroups.map(group => ({
                            title: group.title,
                            items: group.items.map(item => ({
                                id: item.id,
                                name: item.name,
                                path: item.path,
                            })),
                        })),
                    },
                    { key: 'retail', title: '零售中心', type: 'link', path: '/retail' },
                    { key: 'service', title: '服务中心', type: 'link', path: '/service' },
                    {
                        key: 'about',
                        title: '关于我们',
                        type: 'accordion',
                        groups: [
                            {
                                title: '',
                                items: [
                                    { name: '东风快讯', path: '/about/news' },
                                    { name: '关于我们', path: '/about' },
                                    { name: '联系我们', path: '/about/contact' },
                                ],
                            },
                        ],
                    },
                    {
                        key: 'tools',
                        title: '其他工具',
                        type: 'accordion',
                        groups: [
                            {
                                title: '',
                                items: [
                                    { name: '车型参数对比', path: '/tools/compare' },
                                    { name: '金融试算器', path: '/tools/finance' },
                                ],
                            },
                        ],
                    },
                ];

                if (this.loggedIn) {
                    list.push({
                        key: 'user',
                        title: '个人中心',
                        type: 'accordion',
                        groups: [
                            {
                                title: '',
                                items: [
                                    { name: '个人信息', path: '/userCenter', action: 'profile' },
                                    { name: '我的预订', path: '/my/bookings', action: 'orders' },
                                    { name: '我的预约试驾', path: '/my/testdrives', action: 'testdrive' },
                                    { name: '退出登录', action: 'logout' },
                                ],
                            },
                        ],
                    });
                } else {
                    list.push({
                        key: 'login',
                        title: '请登录',
                        type: 'link',
                        action: 'login',
                    });
                }

                return list;
            },
        },
        methods: {
            /** 接口返回的车型和技术名称已完成多语言处理，直接展示原值。 */
            formatItemName(section, item) {
                if (!item) return '';
                if (section && (section.key === 'models' || section.key === 'technology')) {
                    return item.name || '';
                }
                return this.$t(item.name || '');
            },
            toggle(key) {
                this.expandedKey = this.expandedKey === key ? '' : key;
            },
            onItemClick(item) {
                if (!item) return;
                if (item.action === 'logout') {
                    this.$emit('logout');
                    return;
                }
                if (item.action === 'login') {
                    this.$emit('login');
                    return;
                }
                this.$emit('navigate', item);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .df-mnav {
        position: fixed;
        top: 50px;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 65;
        background: #ffffff;
        color: #1a1a1a;
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
        transform: translateY(-6px);
        transition: opacity 0.28s ease, transform 0.28s ease, visibility 0.28s ease;

        &.is-open {
            opacity: 1;
            visibility: visible;
            pointer-events: auto;
            transform: translateY(0);
        }
    }

    .df-mnav__scroll {
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        overscroll-behavior: contain;
        -webkit-overflow-scrolling: touch;
        /* Figma 为 2x，间距按一半落地 */
        padding: 20px 12px 40px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        scrollbar-width: none;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    .df-mnav__block {
        width: 100%;
    }

    .df-mnav__head,
    .df-mnav__link {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 0;
        border: none;
        background: transparent;
        color: #1a1a1a;
        font-size: 14px;
        font-weight: 500;
        line-height: 2;
        text-align: left;
        cursor: pointer;
    }

    .df-mnav__link {
        display: block;
    }

    .df-mnav__arrow {
        width: 12px;
        height: 12px;
        font-size: 12px;
        line-height: 12px;
        text-align: center;
        color: #1a1a1a;
        transition: transform 0.22s ease;
        flex-shrink: 0;

        &.is-open {
            transform: rotate(180deg);
        }
    }

    .df-mnav__panel {
        margin: 8px -12px 0;
        width: calc(100% + 24px);
        padding: 12px;
        background: #f8f8f8;
        display: flex;
        flex-direction: column;
        gap: 20px;
        box-sizing: border-box;
    }

    .df-mnav__group {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .df-mnav__category-tabs {
        display: flex;
        gap: 16px;
        padding-bottom: 12px;
        border-bottom: 1px solid #e6e6e6;
    }

    .df-mnav__category-tab {
        padding: 0;
        border: 0;
        background: transparent;
        color: #666666;
        font-size: 14px;
        line-height: 1.5;

        &.is-active {
            color: #e60021;
            font-weight: 600;
        }
    }

    .df-mnav__cat {
        font-size: 12px;
        font-weight: 400;
        line-height: 2.3;
        color: #e60021;
    }

    .df-mnav__list {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .df-mnav__item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        color: #1a1a1a;
        text-decoration: none;
    }

    .df-mnav__item-name {
        font-size: 14px;
        font-weight: 400;
        line-height: 2;
    }

    .df-mnav__item-price {
        flex-shrink: 0;
        font-size: 14px;
        font-weight: 400;
        line-height: 2;
        color: #1a1a1a;
        text-align: right;
    }
</style>
